import { render, staticRenderFns } from "./InformationFour.vue?vue&type=template&id=440d42c8&"
import script from "./InformationFour.vue?vue&type=script&lang=js&"
export * from "./InformationFour.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/dynamicInformation/Information.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports